import { ChainId } from '@src/configs/chainInfo'
import { GasFeeSimulationResults } from '@src/types/gasFees'
import { PrecomputeGasResults } from '@src/types/gasPrices'
import { createContextLogger } from '@src/utils/logger'

const logger = createContextLogger('approximateGasFees')

export const approximateGasFeesTron = (
    precomputedGasPrices: PrecomputeGasResults,
    precomputed_results: GasFeeSimulationResults[]
): GasFeeSimulationResults => {
    try {
        if (!precomputedGasPrices[ChainId.Tron]) {
            throw new Error(`[approximateGasFees] precomputedGasPrices does not contain data for Tron`)
        }

        return {
            totalGasUnits: BigInt(0),
            individualGasUnits: [BigInt(0)],
            totalFeePerGasUnit: BigInt(0),
            feeMetrics: precomputed_results[0].feeMetrics,
            tronResults: {
                totalEnergyUsed:
                    BigInt(7) *
                    precomputed_results.reduce(
                        (acc, val) => acc + (val.tronResults?.totalEnergyUsed ?? BigInt(0)),
                        BigInt(0)
                    ),
                totalBandWidthUsed: precomputed_results.reduce(
                    (acc, val) => acc + (val.tronResults?.totalBandWidthUsed ?? BigInt(0)),
                    BigInt(0)
                ),
            },
        } as GasFeeSimulationResults
    } catch (err) {
        logger.error('Cannot approximate Tron gas fees', { error: err })
        return {
            totalGasUnits: BigInt(0),
            individualGasUnits: [BigInt(0)],
            totalFeePerGasUnit: BigInt(0),
            feeMetrics: {},
        } as GasFeeSimulationResults
    }
}
